import { combineReducers } from 'redux';

import onboardingInformationSlice from './onboardingInformation/onboardingInformationSlice';
import miscSlice from './miscellaneous/miscSlice';
import abTestingSlice from './abTest/abTestingSlice';

const rootReducer = combineReducers({
  onboardingInfo: onboardingInformationSlice,
  abTesting: abTestingSlice,
  misc: miscSlice
});

export default rootReducer;
